<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title"><span translate>LBL.ATTACHMENTS</span></h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body callAttachment">
        <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
        <sk-wave [isRunning]="IsSubmitting"></sk-wave>
        <form name="frm">
            <div class="row form-group">
                <label class="col-3 col-form-label" translate>LBL.NO_OF_ATTACHMENTS</label>
                <div class="col-3 col-form-label">{{lstBind.length}}</div>
                <label class=".col-sm-6" translate>LBL.MAX_UPLOAD_SIZE</label>
                <div class="col-auto">{{MaximumUploadSize}}</div>
            </div>

            <div class="row form-group">
                <label class="col-3 col-form-label" translate>LBL.UPLOAD_NEW_FILE</label>
                <div class="col-8">
                    <input type="file" [hidden]="true" #chooseFile class="custom-file" name="file" (change)="onFileChanged($event)" title="{{'TITLE.TITLE_UPLOAD_FILE' | translate}}" multiple />
                    <button type="button" class="btn btn-default" (click)="chooseFile.click()">
                        {{'TITLE.TITLE_UPLOAD_FILE' | translate}}
                    </button>
                    <span></span>
                </div>
            </div>
        </form>

        <div class="row border-top pt-3 callAttachment">
            <div class="col" *ngIf="lstBind.length == 0">
                <span translate>LBL.NO_ATTACHMENT</span>
            </div>
            <div class="col-3 mb-3" *ngFor="let row of lstBind; let idx = index;">
                <div>
                    <img *ngIf="_MasterConstants.IsImage(row.FileName)" class="img-thumbnail imgPreview" [src]="_sanitizer.bypassSecurityTrustUrl('' + row.Base64String)" />
                    <div class="img-thumbnail imgPreview  d-flex align-items-center justify-content-center" *ngIf="!_MasterConstants.IsImage(row.FileName)"><img class="" src="/Assets/FileIcons/48px/{{GetFileExtension(row.FileName)}}.png" /></div>
                </div>
                <div class="ellipsis">{{row.FileName}}</div>
                <div><a class="" href="javascript:{}" (click)="onDelete(idx)"><span translate>LBL.DELETE</span></a></div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="onSelect()"><span *ngIf="OnlyNew" translate>BTN.BTN_OK</span><span *ngIf="!OnlyNew" translate>BTN.BTN_OK</span></button>
        <button class="btn btn-secondary" (click)="d('Close')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>
